import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=1e725b7b&scoped=true&"
import script from "./ObjectCard.vue?vue&type=script&lang=js&"
export * from "./ObjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCard.vue?vue&type=style&index=0&id=1e725b7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e725b7b",
  null
  
)

export default component.exports